import React, { useState } from 'react';
import { TWButton, TWInput, TWModal } from '../../../components/ui';

const KioskLinkUpsertModal = ({ show, onClose, loading, onSubmit, kiosk }) => {
  const [link, setLink] = useState('');

  return (
    <TWModal
      open={show}
      onClose={onClose}
      title="Reader Link"
      description="Create a reader link for your kiosk"
      size="2xl"
      showCloseButton
      footer={
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
          <TWButton
            variant="default"
            label="Cancel"
            disabled={loading}
            onClick={onClose}
            className="w-full sm:w-auto"
          />
          <TWButton
            variant="primary"
            label="Submit"
            disabled={loading}
            loading={loading}
            onClick={() => onSubmit(link)}
            className="w-full sm:w-auto"
          />
        </div>
      }
    >
      <TWInput
        label="Reader Link"
        value={link || kiosk?.link || ''}
        onChange={(e) => setLink(e.target.value)}
        placeholder="e.g. 'https://thisway.esper.cloud/devices/{id}/remoteview'"
      />
    </TWModal>
  );
};

export default KioskLinkUpsertModal;
